import React from 'react'


const TextSpacer = () =>{
    return <div className='spacer h-70'></div>
}

export default TextSpacer